<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          Confirm Delete User Guide
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to delete this <Strong>{{ UserGuide.title }}</Strong> User Guide?
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            This action cannot be undone.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="error" variant="flat" @click="handleDelete" :loading="loading">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { generateClient } from "aws-amplify/api";
import { edit_user_guide_topic } from "@/graphql/mutations";
const client = generateClient();
export default {
  name: "DeleteUserGuideDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    UserGuide: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      if (!this.UserGuide?.guide_topic_id) {
        return;
      }

      this.loading = true;
      try {
        // Using edit mutation to set status to DEACTIVE as delete placeholder
        const input = {
          guide_topic_id: this.UserGuide.guide_topic_id,
          guide_topic_status: "DEACTIVE",
        };

        const response = await client.graphql({
          query: edit_user_guide_topic,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.edit_user_guide_topic);
        // console.log(responseData);

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "User Guide deleted successfully!",
            color: "success",
          };
          this.dialog = false;
          this.$emit("deleted");
        } else {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to delete UserGuide",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error deleting UserGuide:", error);
        this.snackbar = {
          show: true,
          message: (error.errors && error.errors[0]?.message) || error.message || "An error occurred while deleting UserGuide",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
